function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Collection Template
 *    Contains all the scripts used for the collection template.
 *
 *  Version:
 *    1.0.0 - 2020/03/10
 */

import $ from 'jquery';
import * as noUiSlider from 'nouislider';
import { Accordion } from './../objects/content/Accordion';
import { InitializeInactiveThumbnails } from './../objects/product/ProductThumbnail';
import * as ResponsiveSizes from '../settings/Responsive';

//Ajax Collection Imports
import { AjaxCollectionTemplate, SelectSorter, TagFilter, TypeFilter, PriceRangeFilter, VariantOptionFilter, VO_MODE_PRODUCT, OPERATION_OR, LoadMore } from '@process-creative/slate-ajax-collection';

//Custom Filters & Facets
import { CustomPriceSlideFacet } from './../components/facets/CustomPriceSlideFacet';
import { SizeCheckboxFacetUpdated } from './../components/facets/SizeFacet';
import { SmartTagCheckboxFacetUpdated } from './../components/facets/SmartTagCheckboxFacetUpdated';
import { TypeFacetUpdated } from './../components/facets/TypeFacetUpdated';
import { ProductThumbnailPrint } from './../objects/product/ProductThumbnailPrint';
import { LoadMoreUpdated } from '../components/facets/load-more-updated';
import { ArtProductThumbnailPrint } from '../objects/product/ArtProductThumbnailPrint';

//Selectors
export var CONTAINER_SELECTOR = '[data-collection-template]';
export var LOAD_MORE_BUTTON_SELECTOR = '[data-collection-template-load-more]';
export var SORT_SELECT_SELECTOR = '[data-collection-template-sort]';
export var TOGGLE_FILTERS = '[data-collection-template-toggle-filters]';
export var NO_RESULTS_SELECTOR = '[data-collection-no-results]';
export var COLLECTION_FAQS = '[data-collection-faq]';
export var COLLECTION_DISPLAY_MODE = 'data-collection-dm';
var SELECTOR_PRODUCTS_CONTAINER = '[data-collection-template-products]';
var SELECTOR_PRODUCT_ELEMENT = '[data-product-thumbnail]';
var SELECTOR_CONTENT_BLOCK_ELEMENT = '[data-content-block]';
var SELECTOR_SORT_SIZING = '[data-sort-sizing]';
var FILTER_COUNT_CONTAINER = '[data-filter-count]';

//Faceted Nav Selectors
export var FACETED_NAV_SELECTOR = '[data-faceted-nav]';
export var FACETED_NAV_TYPES_SELECTOR = '[data-faceted-nav-types]';
export var FACETED_NAV_SIZE_SELECTOR = '[data-faceted-nav-size]';
export var FACETED_NAV_GRADE_SELECTOR = '[data-faceted-nav-grade]';
export var FACETED_NAV_CAMERA_TYPE_SELECTOR = '[data-faceted-nav-camera-type]';
export var FACETED_NAV_LENS_MOUNT_SELECTOR = '[data-faceted-nav-lens-mount]';
export var FACETED_NAV_CAMERA_MOUNT_SELECTOR = '[data-faceted-nav-camera-mount]';
export var FACETED_NAV_SUBJECT_SELECTOR = '[data-faceted-nav-subject]';
export var FACETED_NAV_ARTIST_SELECTOR = '[data-faceted-nav-artist]';
export var FACETED_NAV_PRICE_SELECTOR = '[data-faceted-nav-price]';
export var FACETED_NAV_GROUP = '[data-faceted-nav-group]';
export var FACETED_NAV_TITLE = '.c-collection-faceted-nav__title';
export var FACTED_SUBNAV = '[data-faceted-subnav]';
var FACETED_NAV_BACK = '[data-facet-back]';
export var FACETED_NAV_CLEAR_FILTERS = '[data-collection-template-clear-filters]';
export var FACETED_NAV_CLEAR_FILTERS_ROW = '[data-collection-template-clear-row]';
export var FACETED_NAV_ACTIVE_FILTERS_CONTAINER = '[data-collection-template-active-filters-container]';
export var FACETED_NAV_ACTIVE_FILTER = 'data-collection-active-filter';
export var FACETED_NAV_ACTIVE_FILTER_INDEX = 'data-collection-active-filter-index';
export var FACETED_NAV_ACTIVE_FILTER_TYPE = 'data-collection-active-filter-type';
export var FACETED_NAV_COUNT = '[data-collection-template-product-count]';
export var ATTR_CONTENT_BLOCK_POSITION = 'data-content-block-position';
var ATTR_TEMPLATE = 'data-template';

//Classes
var CLASS_FILTERS_OPEN = 'is-filters-open';
var CLASS_EXPANDED = 'is-expanded';
var CLASS_PRODUCT_THUMB = 'c-collection-template__product';
var CLASS_PRODUCT_THUMB_ART = 'c-art-collection__product';
var CLASS_VISIBLE = 'is-visible';
var CLASS_LAST_IN_ROW = 'is-last-in-row';
export var CollectionTemplate = /*#__PURE__*/function (_AjaxCollectionTempla) {
  _inherits(CollectionTemplate, _AjaxCollectionTempla);
  var _super = _createSuper(CollectionTemplate);
  function CollectionTemplate(container) {
    var _this;
    _classCallCheck(this, CollectionTemplate);
    _this = _super.call(this, container);

    //Setup Display Mode
    if (_this.container.attr(COLLECTION_DISPLAY_MODE) == 'variants') {
      _this.draw.setDisplayMode('AllAvailableVariants');
      _this.isVariant = true;
    } else {
      _this.draw.setDisplayMode('FirstAvailableVariant');
    }

    //Current template type, based on liquid template.suffix
    _this.templateType = _this.container.attr(ATTR_TEMPLATE) || false;

    //Setup Pagination
    if (_this.isArtTemplate()) {
      //Content block position aware
      _this.pagination.setPaginator(new LoadMoreUpdated(_assertThisInitialized(_this), _this.container.find(LOAD_MORE_BUTTON_SELECTOR)));
    } else {
      //Contend block position unaware
      _this.pagination.setPaginator(new LoadMore(_assertThisInitialized(_this), container.find(LOAD_MORE_BUTTON_SELECTOR)));
    }

    //Setup Sort
    _this.sort.addSorter(new SelectSorter(_assertThisInitialized(_this), $(SORT_SELECT_SELECTOR)));

    //Setup Filters
    [_this.typesFilter = new TypeFilter(_assertThisInitialized(_this), 'type'), _this.sizeFilter = new VariantOptionFilter(_assertThisInitialized(_this), 'size', OPERATION_OR, ['size'], VO_MODE_PRODUCT), _this.gradeFilter = new TagFilter(_assertThisInitialized(_this), 'tag', OPERATION_OR), _this.cameraTypeFilter = new TagFilter(_assertThisInitialized(_this), 'tag', OPERATION_OR), _this.lensMountFilter = new TagFilter(_assertThisInitialized(_this), 'tag', OPERATION_OR), _this.cameraMountFilter = new TagFilter(_assertThisInitialized(_this), 'tag', OPERATION_OR), _this.subjectFilter = new TagFilter(_assertThisInitialized(_this), 'tag', OPERATION_OR), _this.artistFilter = new TagFilter(_assertThisInitialized(_this), 'tag', OPERATION_OR), _this.priceFilter = new PriceRangeFilter(_assertThisInitialized(_this), 'price')].forEach(function (e) {
      return _this.filters.addFilter(e);
    });

    //Setup Facets
    [_this.typesFacet = new TypeFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.typesFilter,
      title: "".concat(Language.strings['collections.filters.type_title']),
      container: FACETED_NAV_TYPES_SELECTOR
    }), _this.sizeFacet = new SizeCheckboxFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.sizeFilter,
      title: "".concat(Language.strings['collections.filters.size_title']),
      container: FACETED_NAV_SIZE_SELECTOR
    }), _this.gradeFacet = new SmartTagCheckboxFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.gradeFilter,
      title: "".concat(Language.strings['collections.filters.grade_title']),
      container: FACETED_NAV_GRADE_SELECTOR,
      prefixes: ['GRADE']
    }), _this.cameraTypeFacet = new SmartTagCheckboxFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.cameraTypeFilter,
      title: "".concat(Language.strings['collections.filters.camera_type_title']),
      container: FACETED_NAV_CAMERA_TYPE_SELECTOR,
      prefixes: ['Camera Type']
    }), _this.lensMountFacet = new SmartTagCheckboxFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.lensMountFilter,
      title: "".concat(Language.strings['collections.filters.lens_mount_title']),
      container: FACETED_NAV_LENS_MOUNT_SELECTOR,
      prefixes: ['Lens Mount']
    }), _this.cameraMountFacet = new SmartTagCheckboxFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.cameraMountFilter,
      title: "".concat(Language.strings['collections.filters.camera_mount_title']),
      container: FACETED_NAV_CAMERA_MOUNT_SELECTOR,
      prefixes: ['Camera Mount']
    }), _this.subjectFacet = new SmartTagCheckboxFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.subjectFilter,
      title: "".concat(Language.strings['collections.filters.subject_title']),
      container: FACETED_NAV_SUBJECT_SELECTOR,
      prefixes: ['Subject']
    }), _this.artistFacet = new SmartTagCheckboxFacetUpdated({
      template: _assertThisInitialized(_this),
      filter: _this.artistFilter,
      title: "".concat(Language.strings['collections.filters.artist_title']),
      container: FACETED_NAV_ARTIST_SELECTOR,
      prefixes: ['Artist']
    }), _this.priceFacet = new CustomPriceSlideFacet({
      template: _assertThisInitialized(_this),
      filter: _this.priceFilter,
      title: "".concat(Language.strings['collections.filters.price_title']),
      container: FACETED_NAV_PRICE_SELECTOR,
      noUiSlider: noUiSlider
    })].forEach(function (facet) {
      return _this.filters.addFacet(facet);
    });

    //Elements
    _this.facets = container.find(FACETED_NAV_SELECTOR);
    _this.count = container.find(FACETED_NAV_COUNT);
    _this.noResults = container.find(NO_RESULTS_SELECTOR);
    _this.clearFiltersRow = container.find(FACETED_NAV_CLEAR_FILTERS_ROW);
    _this.activeFiltersContainer = container.find(FACETED_NAV_ACTIVE_FILTERS_CONTAINER);
    _this.facetToggle = [_this.facets, $('body')];
    _this.productsContainerElement = container[0].querySelector(SELECTOR_PRODUCTS_CONTAINER);
    _this.sortElement = container[0].querySelector(SORT_SELECT_SELECTOR);
    _this.sortSizing = container[0].querySelector(SELECTOR_SORT_SIZING);
    _this.faq = new Accordion(container.find(COLLECTION_FAQS));
    _this.printedContentBlocks = [];

    //Art template specific
    if (_this.isArtTemplate()) {
      _this.pagination.paginateContentAware = true;
      // this.calculateLastInRow();
      // window.addEventListener('resize', () => this.calculateLastInRow());
      if (_this.sortSizing) _this.setSortWidth();
    }

    //Events
    container.on('click', TOGGLE_FILTERS, function (e) {
      return _this.onFiltersToggle(e);
    });
    container.on('click', FACETED_NAV_TITLE, function (e) {
      return _this.onFacetToggle(e);
    });
    container.on('click', FACETED_NAV_BACK, function (e) {
      return _this.onFacetClose(e);
    });
    container.on('click', FACETED_NAV_CLEAR_FILTERS, function (e) {
      return _this.onClearFilters(e);
    });
    container.on('click', "[".concat(FACETED_NAV_ACTIVE_FILTER, "]"), function (e) {
      return _this.onActiveFilterClear(e);
    });
    return _this;
  }
  _createClass(CollectionTemplate, [{
    key: "onSort",
    value: function onSort(_ref) {
      var method = _ref.method,
        variants = _ref.variants,
        sorted = _ref.sorted;
      if (this.sortSizing) this.setSortWidth();
      return sorted;
    }
  }, {
    key: "generatePrint",
    value: function generatePrint(v, index) {
      var p = v.product;
      var url = this.getVariantUrl(v);
      var p2 = _objectSpread({}, p); //Duplicate
      p2.variants = p2.variants.map(function (variant) {
        var v2 = _objectSpread({}, variant); //Duplicate
        delete v2.product; //Remove circular reference
        return v2;
      });
      if (this.isArtTemplate()) {
        return ArtProductThumbnailPrint(p, p2, v, CLASS_PRODUCT_THUMB_ART, url);
      } else {
        return ProductThumbnailPrint(p, p2, v, CLASS_PRODUCT_THUMB, url, this.isVariant);
      }
    }
  }, {
    key: "getContentBlockPosition",
    value: function getContentBlockPosition(cb, thumbnails) {
      if (thumbnails.length <= 0) return -1; //No thumbs? hide
      if (this.contentBlockIsOnPage(cb, this.pagination.template.perPage, this.pagination.getCurrentPage(), thumbnails.length)) {
        cb.addClass(CLASS_VISIBLE);
      } else {
        cb.removeClass(CLASS_VISIBLE);
        return;
      }
      var originalPosition = parseInt(cb.attr(ATTR_CONTENT_BLOCK_POSITION));
      return originalPosition;
    }
  }, {
    key: "onActiveFilterClear",
    value: function onActiveFilterClear(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      var filter = self.attr(FACETED_NAV_ACTIVE_FILTER);
      var index = parseInt(self.attr(FACETED_NAV_ACTIVE_FILTER_INDEX));
      var type = self.attr(FACETED_NAV_ACTIVE_FILTER_TYPE);
      if (!filter || index < 0 || !type) return;
      switch (type) {
        case "types":
          this.filters.filters[index].removeType(filter);
          break;
        case "options":
          this.filters.filters[index].removeOption(filter);
          break;
        case "tags":
          this.filters.filters[index].removeTag(filter);
          break;
        case "range":
          this.filters.filters[index].clear();
      }
    }
  }, {
    key: "onClearFilters",
    value: function onClearFilters(e) {
      e.stopPropagation();
      e.preventDefault();
      this.filters.clearFilters();
    }
  }, {
    key: "onFacetToggle",
    value: function onFacetToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      var group = self.parent(FACETED_NAV_GROUP);
      group.toggleClass(CLASS_EXPANDED);

      // removed CLASS_EXPANDED
      // this.subfacetToggle.forEach(e => e.toggleClass(CLASS_FILTERS_OPEN));
    }
  }, {
    key: "onFacetClose",
    value: function onFacetClose(e) {
      e.preventDefault();
      e.stopPropagation();
      var navGroup = document.querySelectorAll(FACETED_NAV_GROUP);
      navGroup.forEach(function (cont) {
        cont.classList.remove(CLASS_EXPANDED);
      });
    }
  }, {
    key: "onFiltersToggle",
    value: function onFiltersToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      this.facetToggle.forEach(function (e) {
        return e.toggleClass(CLASS_FILTERS_OPEN);
      });
      this.onFacetClose(e);
      var filterCount = document.querySelectorAll(FILTER_COUNT_CONTAINER);
      setTimeout(function () {
        filterCount.forEach(function (count) {
          return count.classList.add(CLASS_VISIBLE);
        });
      }, 1000);
    }
  }, {
    key: "onFilter",
    value: function onFilter() {
      this.clearFiltersRow.addClass(CLASS_VISIBLE);

      //Keys must be in the order of the filters defined above. Any changes
      //to the filters must be mimmicked here.
      var keys = ['types', 'options', 'tags', 'tags', 'tags', 'tags', 'tags', 'tags', 'range'];

      //Loop through filters and find active values
      var print = this.filters.filters.reduce(function (x, filter, i) {
        var key = keys[i];
        var activeFilters = filter[key];
        if (!activeFilters || !activeFilters.length) return x; //No active filters for this filter

        return x += activeFilters.reduce(function (y, af) {
          return y += "\n          <span\n            class=\"c-collection-faceted-nav__clear-filter\"\n            data-collection-active-filter-index=\"".concat(i, "\"\n            data-collection-active-filter=\"").concat(af, "\"\n            data-collection-active-filter-type=\"").concat(key, "\"\n          >\n            ").concat(af.split('_').length > 1 ? "".concat(af.split('_')[1]) : "".concat(af), "\n            <svg class=\"o-icon c-collection-faceted-nav__clear-filter-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\"><path d=\"M.75.75l13 13m0-13l-13 13\" fill=\"none\" stroke=\"#111\" stroke-width=\"1.5\" stroke-linecap=\"square\"/></svg>\n          </span>\n        ");
        }, '');
      }, '');
      this.activeFiltersContainer.html(print);
    }
  }, {
    key: "onVariantsDrawn",
    value: function onVariantsDrawn(variants) {
      var count = this.draw.unpaginatedProductCount;
      this.count.html("".concat(count));
      if (this.filters.isFiltering()) {
        this.onFilter();
      } else {
        this.clearFiltersRow.removeClass(CLASS_VISIBLE);
      }
      if (variants.length) {
        this.noResults.removeClass(CLASS_VISIBLE);
        InitializeInactiveThumbnails();
        return;
      }

      //Show empty message
      this.noResults.addClass(CLASS_VISIBLE);
      if (this.isArtTemplate()) this.calculateLastInRow();
    }
  }, {
    key: "calculateLastInRow",
    value: function calculateLastInRow() {
      //Adds a class to the last product or content block in each flex row
      if (window.innerWidth < ResponsiveSizes.small) return;
      var elements = this.productsContainerElement.querySelectorAll("".concat(SELECTOR_PRODUCT_ELEMENT, ", ").concat(SELECTOR_CONTENT_BLOCK_ELEMENT));
      var containerOffset = this.productsContainerElement.offsetRight;
      elements.forEach(function (element) {
        if (element.offsetRight == containerOffset) {
          element.classList.add(CLASS_LAST_IN_ROW);
        } else {
          element.classList.remove(CLASS_LAST_IN_ROW);
        }
      });
    }
  }, {
    key: "contentBlockIsOnPage",
    value: function contentBlockIsOnPage(contentBlock, perPage, currentPage, productsShown) {
      //OG Position of the block from the data attr
      var blockOriginalPosition = parseInt(contentBlock.attr('data-content-block-position')) || 999;

      //Load More DM requires CB to be visible after page 1,
      //this kind of works however it is not aware of the other content blocks
      //have already been printed on the page that have been printed on the page
      // return blockOriginalPosition < (currentPage * perPage);

      //Index of the block in the printed blocks array
      var blockIndex = this.printedContentBlocks ? this.printedContentBlocks.indexOf(blockOriginalPosition) : -1;

      //How many content blocks have been printed and what is their size?
      var offset = this.getContentBlockSize();
      var countOfPrintedBlocks = this.printedContentBlocks.length * offset;
      var blockNewPosition = blockOriginalPosition + countOfPrintedBlocks;
      if (blockIndex != -1) blockNewPosition -= offset;

      // Hide blocks with index past number of products
      if (blockNewPosition > productsShown) return false;
      var shouldBlockBeOnPage = blockNewPosition < currentPage * perPage;
      if (shouldBlockBeOnPage && blockIndex == -1) {
        this.printedContentBlocks.push(blockOriginalPosition);
      } else {
        this.printedContentBlocks.splice(blockIndex, 1);
      }
      return shouldBlockBeOnPage;
    }
  }, {
    key: "getContentBlocksForPage",
    value: function getContentBlocksForPage(params) {
      var _this2 = this;
      var productsShown = params.paginator.template.draw.drawnProducts.length;
      try {
        var contentBlocks = params.contentBlocks.filter(function (c) {
          return _this2.contentBlockIsOnPage($(c), params.perPage, params.page, productsShown);
        });
        if (contentBlocks.length) return contentBlocks;
        return -1;
      } catch (e) {
        console.error(e);
        return -1;
      }
    }
  }, {
    key: "getContentBlockSize",
    value: function getContentBlockSize(params) {
      return 2;
    }
  }, {
    key: "setSortWidth",
    value: function setSortWidth() {
      // Updates the width of the sort element by using a hidden sizing element
      // to update the current selected value and measure its width
      var selected = this.sortElement.options[this.sortElement.selectedIndex].text;
      //Avoid updating element if the value doesn't change
      if (selected !== this.currentSortValue) {
        this.sortSizing.innerHTML = "<option>".concat(selected, "</option>");
      }
      this.currentSortValue = selected;
      var width = this.sortSizing.offsetWidth;
      //Avoid updating width if the value doesn't change
      if (width === this.currentSortWidth) return;
      this.currentSortWidth = width;
      this.sortElement.style.width = "".concat(width, "px");
    }
  }, {
    key: "isArtTemplate",
    value: function isArtTemplate() {
      return this.templateType === 'art';
    }
  }]);
  return CollectionTemplate;
}(AjaxCollectionTemplate);

/*** Initialize Collection Template ***/
$(document).ready(function () {
  //Find container
  var container = $(CONTAINER_SELECTOR);
  if (!container.length) return;
  if (container.attr('data-initialized')) return;

  //Create the template, we use window.collection for TESTING only!!
  var template = window.collection = new CollectionTemplate(container);

  //Now initialize it
  template.init();
});